/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceHighlight } from './EvidenceHighlight';
import {
  EvidenceHighlightFromJSON,
  EvidenceHighlightFromJSONTyped,
  EvidenceHighlightToJSON,
} from './EvidenceHighlight';
import type { FindingSourceEnum } from './FindingSourceEnum';
import {
  FindingSourceEnumFromJSON,
  FindingSourceEnumFromJSONTyped,
  FindingSourceEnumToJSON,
} from './FindingSourceEnum';
import type { SeverityLabelEnum } from './SeverityLabelEnum';
import {
  SeverityLabelEnumFromJSON,
  SeverityLabelEnumFromJSONTyped,
  SeverityLabelEnumToJSON,
} from './SeverityLabelEnum';
import type { RiskMetricResultSummary } from './RiskMetricResultSummary';
import {
  RiskMetricResultSummaryFromJSON,
  RiskMetricResultSummaryFromJSONTyped,
  RiskMetricResultSummaryToJSON,
} from './RiskMetricResultSummary';

/**
 *
 * @export
 * @interface Finding
 */
export interface Finding {
  /**
   *
   * @type {number}
   * @memberof Finding
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof Finding
   */
  readonly riskIndicator: number;
  /**
   *
   * @type {Array<RiskMetricResultSummary>}
   * @memberof Finding
   */
  readonly explains: Array<RiskMetricResultSummary>;
  /**
   *
   * @type {string}
   * @memberof Finding
   */
  readonly title: string;
  /**
   *
   * @type {string}
   * @memberof Finding
   */
  readonly summary: string;
  /**
   *
   * @type {Array<object>}
   * @memberof Finding
   */
  readonly evidence: Array<object>;
  /**
   *
   * @type {Array<EvidenceHighlight>}
   * @memberof Finding
   */
  readonly evidenceHighlights: Array<EvidenceHighlight>;
  /**
   * Row count per dataset of the assessed pipeline: "original" for the baseline, otherwise the perturbation's display name. Null if unreadable.
   * @type {{ [key: string]: number | null; }}
   * @memberof Finding
   */
  readonly datasetRowCounts: { [key: string]: number | null };
  /**
   *
   * @type {number}
   * @memberof Finding
   */
  readonly severity: number;
  /**
   * Band derived from severity: >= 0.7 high, 0.5-0.7 medium, below 0.5 low.
   * @type {SeverityLabelEnum}
   * @memberof Finding
   */
  readonly severityLabel: SeverityLabelEnum;
  /**
   *
   * @type {number}
   * @memberof Finding
   */
  readonly confidence: number;
  /**
   *
   * @type {Date}
   * @memberof Finding
   */
  readonly timestamp: Date;
  /**
   *
   * @type {FindingSourceEnum}
   * @memberof Finding
   */
  readonly source: FindingSourceEnum;
  /**
   *
   * @type {boolean}
   * @memberof Finding
   */
  readonly reviewed: boolean;
}

/**
 * Check if a given object implements the Finding interface.
 */
export function instanceOfFinding(value: object): value is Finding {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('riskIndicator' in value) || value['riskIndicator'] === undefined) return false;
  if (!('explains' in value) || value['explains'] === undefined) return false;
  if (!('title' in value) || value['title'] === undefined) return false;
  if (!('summary' in value) || value['summary'] === undefined) return false;
  if (!('evidence' in value) || value['evidence'] === undefined) return false;
  if (!('evidenceHighlights' in value) || value['evidenceHighlights'] === undefined) return false;
  if (!('datasetRowCounts' in value) || value['datasetRowCounts'] === undefined) return false;
  if (!('severity' in value) || value['severity'] === undefined) return false;
  if (!('severityLabel' in value) || value['severityLabel'] === undefined) return false;
  if (!('confidence' in value) || value['confidence'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  if (!('source' in value) || value['source'] === undefined) return false;
  if (!('reviewed' in value) || value['reviewed'] === undefined) return false;
  return true;
}

export function FindingFromJSON(json: any): Finding {
  return FindingFromJSONTyped(json, false);
}

export function FindingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Finding {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    riskIndicator: json['risk_indicator'],
    explains: (json['explains'] as Array<any>).map(RiskMetricResultSummaryFromJSON),
    title: json['title'],
    summary: json['summary'],
    evidence: json['evidence'],
    evidenceHighlights: (json['evidence_highlights'] as Array<any>).map(EvidenceHighlightFromJSON),
    datasetRowCounts: json['dataset_row_counts'],
    severity: json['severity'],
    severityLabel: SeverityLabelEnumFromJSON(json['severity_label']),
    confidence: json['confidence'],
    timestamp: new Date(json['timestamp']),
    source: FindingSourceEnumFromJSON(json['source']),
    reviewed: json['reviewed'],
  };
}

export function FindingToJSON(
  value?: Omit<
    Finding,
    | 'id'
    | 'riskIndicator'
    | 'explains'
    | 'title'
    | 'summary'
    | 'evidence'
    | 'evidenceHighlights'
    | 'datasetRowCounts'
    | 'severity'
    | 'severityLabel'
    | 'confidence'
    | 'timestamp'
    | 'source'
    | 'reviewed'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
